import { Component, ElementRef, signal, ViewChild, viewChild, computed, ChangeDetectorRef } from '@angular/core';
import { LoaderService } from '../../../../shared/services/loader.service';
import { AssistanceService } from '../../services/requests-service';
import { ServicesService } from '../../../services/services/services.service';
import { UserService } from '../../../user/services/user.service';
import { CommonModule, NgClass } from '@angular/common';
import { FloatingAssistanceButtonComponent } from '../../../../shared/components/floating-assistance-button/floating-assistance-button.component';
import { MatIconModule } from '@angular/material/icon';
import { NavigationExtras, Router } from '@angular/router';
import { catchError, forkJoin, of } from 'rxjs';

@Component({
  selector: 'app-request',
  standalone: true,
  imports: [
    CommonModule,
    NgClass,
    MatIconModule,
    FloatingAssistanceButtonComponent
  ],
  templateUrl: './request.component.html',
  styleUrl: './request.component.scss'
})
export class RequestComponent {
  @ViewChild('btnActive') btnActive!: ElementRef;
  @ViewChild('btnEnd') btnEnd!: ElementRef;

  servicesName:any[] = [];
  selectedTab = signal('Todos');
  selectedType = signal('Todos');
  assistanceAll:any [] = [];
  assistanceHistory: any [] = [];
  assistanceActive: any [] = [];
  assistanceEnd: any [] = [];

  description: string = '';//en este campo recibiremos 
  study: string = '';
  laboratory: string = ''
  address: string = ''
  isCheckUp: boolean = false;
  
  // Paginación
  currentPage = signal(1);
  itemsPerPage = 10;
  totalPages = signal(1);
  
  // Ordenamiento
  sortOrder = signal('desc'); // 'asc' para ascendente, 'desc' para descendente
  
  // Lista de estatus cerrados
  openStatusList = [0, 11, 100, 101, 102, 103, 104, 106, 107, 108];
  closedStatus = [7, 8, 16, 29, 30, 109, 110];
  finishedStatus = [10, 14, 37, 105, 148];

  constructor(private api:AssistanceService, private apiService: ServicesService, private loader:LoaderService, private router:Router, private cdr: ChangeDetectorRef, private userService: UserService){}

  ngOnInit(){
    this.loader.show();
    this.checkUserCoverage();
  }

  selectTab(tab: string) {
    this.selectedTab.set(tab);
    this.currentPage.set(1);
    this.updateTotalPages();
    this.cdr.detectChanges();
  }

  selectType(type: string) {
    if(type == 'active' && this.selectedType() == 'active'){
      type = 'Todos';
    }      

    if(type == 'end' && this.selectedType() == 'end'){
      type = 'Todos';
    }
      
    this.selectedType.set(type);
    this.currentPage.set(1);
    this.updateTotalPages();
    this.cdr.detectChanges();
  }

  updateTotalPages() {
    const filtered = this.filteredAssistance();
    this.totalPages.set(Math.ceil(filtered.length / this.itemsPerPage));
  }



  filteredAssistance() {
    const current = this.selectedTab();
    const currentType = this.selectedType();
    const order = this.sortOrder();
    let result = [...this.assistanceAll];
    
    if(current !== 'Todos') {
      result = result.filter(s => s?.dsservicio?.toLowerCase().includes(current.toLowerCase()));
    } 
    if(currentType == 'active'){
      result = result.filter(s => this.openStatusList.includes(parseInt(s?.clestatus)))
    } 
    if(currentType == 'end'){
      result = result.filter(s =>
        [...this.closedStatus, ...this.finishedStatus].includes(parseInt(s?.clestatus))
      );
    }
    
    // Ordenamiento por fecha
    result = result.sort((a, b) => {
      const dateA = new Date(a.fecharegistro || a.fechatermino || '1900-01-01');
      const dateB = new Date(b.fecharegistro || b.fechatermino || '1900-01-01');
      
      if (order === 'asc') {
        return dateA.getTime() - dateB.getTime();
      } else {
        return dateB.getTime() - dateA.getTime();
      }
    });
    
    return result;
  }

  paginatedAssistance() {
    const filtered = this.filteredAssistance();
    const startIndex = (this.currentPage() - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return filtered.slice(startIndex, endIndex);
  }

  nextPage() {
    if (this.currentPage() < this.totalPages()) {
      this.currentPage.set(this.currentPage() + 1);
    }
  }

  prevPage() {
    if (this.currentPage() > 1) {
      this.currentPage.set(this.currentPage() - 1);
    }
  }

  toggleSortOrder() {
    const newOrder = this.sortOrder() === 'asc' ? 'desc' : 'asc';
    this.sortOrder.set(newOrder);
    this.currentPage.set(1);
    this.updateTotalPages();
    this.cdr.detectChanges();
  }

  formatDate(dateString: string): string {
    if (!dateString) return 'N/A';
    
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return 'N/A';
      
      const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      };
      
      return date.toLocaleString('es-MX', options);
    } catch (error) {
      return 'N/A';
    }
  }

  getIconForService(dsServicio: string): string {
    if (!dsServicio) return 'help_outline';
    const tipo = dsServicio.replace('Asistencia', '').trim();
    return this.iconForTipo(tipo);
  }

  allServicesClient() {
  
     forkJoin({
    services: this.apiService.getServicesPopular().pipe(
      catchError(err => {
        console.error('Error en services', err);
        return of({ data: [] });
      })
    ),
    history: this.api.getAssistanceHistory().pipe(
      catchError(err => {
        console.error('Error en history', err);
        return of({ data: [] });
      })
    ),
    active: this.api.getAssistanceActive().pipe(
      catchError(err => {
        console.error('Error en active', err);
        return of({ data: [] });
      })
    ),
    end: this.api.getAssistanceEnd().pipe(
      catchError(err => {
        console.error('Error en end', err);
        return of({ data: [] });
      })
    )
  }).subscribe({
      next: ({ services, history, active, end }) => {
        // --- services ---
        if (services?.data) {
          const tiposUnicos = [...new Set(services.data.map(s => s.dsServicio))];
          this.servicesName = [
            { label: 'Todos', value: 'Todos', icon: 'search' },
            ...tiposUnicos.map(dsServicio => ({
              value: dsServicio,
              label: dsServicio === 'Especializados' ? 'Funerarios' : dsServicio,
              icon: this.iconForTipo(dsServicio.replace('Asistencia', '').trim())
            }))
          ];
        }
  
        // --- assistance data ---
        this.assistanceHistory = this.filterValidData(history?.data ?? []);
        this.assistanceActive  = this.filterValidData(active?.data ?? []);
        this.assistanceEnd     = this.filterValidData(end?.data ?? []);
  
        // --- merge everything ---
        this.assistanceAll = this.mergeArrays(
          this.assistanceHistory,
          this.assistanceActive,
          this.assistanceEnd
        );
        
        this.updateTotalPages();
        // Set to show all after data is loaded
        this.selectedType.set('Todos');
        this.updateTotalPages();
  
        this.loader.hide();
      },
      error: (err:any) => {
        console.error('Error al obtener datos', err);
        this.loader.hide();
      }
    });
  }

  private iconForTipo(tipo: string) {
    switch (tipo) {
      case 'Médica': return 'medical_services';
      case 'Vial': return 'directions_car';
      case 'Hogar': return 'home';
      case 'Mascotas': return 'pets';
      case 'Legal': return 'balance';
      default: return 'help_outline';
    }
  }

  normalizeKeys(obj: any): any {
    if (!obj || typeof obj !== 'object') return {};
    
    // Mapa de normalización de nombres de subservicios
    const serviceNameMap: { [key: string]: string } = {
      '433': 'Orientación Médica Online',
      '383': 'Consulta Médica en consultorio',
      '222': 'Handyman',
      '468': 'Deep cleaning',
      '232': 'Concierge',
      '286': 'Asistencia Legal'
    };
    
    // Normalizar dsSubservicio usando el mapa
    if (obj.dsSubservicio && obj.clSubservicio) {
      obj.dsSubservicio = serviceNameMap[obj.clSubservicio] || obj.dsSubservicio;
    }
    
    // Validación para ambulancia internacional - subservicio 241
    if (obj.clSubservicio === '241' && obj.dsSubservicio === 'Ambulancia') {
      obj.dsSubservicio = 'Ambulancia Internacional';
    }
    
    return Object.keys(obj).reduce((acc: any, key: string) => {
      // Preservar claves específicas que necesitan mantener su formato
      if (key === 'dsEstatusBanamex') {
        acc[key] = obj[key];
      } else {
        acc[key.toLowerCase()] = obj[key];
      }
      return acc;
    }, {});
  }

  filterValidData(data: any[]): any[] {
    return data.filter(item => 
      item && 
      item.id !== "4" && 
      !item.descripcion?.includes("No se encontraron resultados")
    );
  }

  mergeArrays(...arrays: any[][]): any[] {
    return arrays.flat()
      .filter(item => item && item.id !== "4" && !item.descripcion?.includes("No se encontraron resultados"))
      .map(item => this.normalizeKeys(item));
  }

  hasAddress(assistance: any): boolean {
    return assistance?.direccion && assistance.direccion !== ', , , México';
  }
  isOfiiceDoctor(assistance: any): boolean {
    return assistance.clsubservicio === '383'; 
  }

  isCheckUpMedical(assistance: any): boolean {
    return assistance.clsubservicio === '377';
  }

  getCheckUpInfo(assistance: any): { estudio: string, laboratorio: string, direccion: string } {
    if (assistance.clsubservicio !== '377') {
      return { estudio: 'N/A', laboratorio: 'N/A', direccion: 'N/A' };
    }

    const text = assistance.descripcionocurrido || '';
    const estudioMatch = text.match(/Estudio:\s*([^–-]+)/);
    const laboratorioMatch = text.match(/Laboratorio:\s*([^–-]+)/);
    const direccionMatch = text.match(/Dirección:\s*(.*)$/);

    return {
      estudio: estudioMatch ? estudioMatch[1].trim() : 'N/A',
      laboratorio: laboratorioMatch ? laboratorioMatch[1].trim() : 'N/A',
      direccion: direccionMatch ? direccionMatch[1].trim() : 'N/A'
    };
  }

  getStatusClass(clEstatus: string): string {
    const status = parseInt(clEstatus);

    if (this.closedStatus.includes(status)) {//deben mostrarse en rojo
      return 'status-finished';
    }

    else if (this.finishedStatus.includes(status)) {//deben mostrarse en azul
      return 'status-concluded';
    }
    // Otros estatus - Color Verde
    return 'status-open';
  }

  getStatusDisplay(clEstatus: string): string {
    const status = parseInt(clEstatus);

    if (this.openStatusList.includes(status)) {
      return 'Abierto';
    }
    else if (this.closedStatus.includes(status)) {
      return 'Cancelado';
    }
    else if (this.finishedStatus.includes(status)) {
      return 'Concluido';
    }
    
    return 'Abierto';
  }

  getSolicitante(assistance: any): string {
    const contacto = assistance?.contacto;
    if (!contacto || contacto === '0' || contacto.trim() === '') {
      return assistance?.nuestrousuario || 'N/A';
    }
    return contacto;
  }


  goToDetail(clExpediente:string, assistance:any):void{
    if(clExpediente == "") return
    
    const processedAssistance = {
      ...assistance,
      contacto: this.getSolicitante(assistance)
    };
    // Si es check-up médico (clsubservicio: 377), navegar al componente específico
    if(assistance?.clsubservicio === '377') {
      const navigationExtras: NavigationExtras = {
        state: {
          serviceResponse: {
            id: clExpediente,
            fechaapertura: assistance.fecharegistro || assistance.fechatermino,
            telefono1: assistance.telefono1 || ''
          },
          fromSelection: true,
          patient: 'titular',
          patientName: assistance.contacto || ''
        }
      };
      this.router.navigate(['solicitud/medical-checkup'], navigationExtras);
      return;
    }
    
    const navigationExtras: NavigationExtras = {
      state: processedAssistance,
      queryParams: processedAssistance
    };
    this.router.navigate(['/solicitud/detalle/', clExpediente], navigationExtras);
  }

  private checkUserCoverage(): void {
    const cognitoId = localStorage.getItem('cognito');
    const account = localStorage.getItem('account');
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const memberships = user.memberships;

    if (!cognitoId || !account || !memberships) {
      this.allServicesClient();
      return;
    }

    this.userService.getPolizas(cognitoId).pipe(
      catchError(err => {
        console.error('Error en getPolizas', err);
        return of({ data: [] });
      })
    ).subscribe(response => {
      const polizas = response?.data || [];
      const matchingPoliza = polizas.find((poliza: any) => poliza.insurance === memberships);
      
      if (matchingPoliza) {
        const products = Array.isArray(matchingPoliza.products) ? matchingPoliza.products : [matchingPoliza.products];
        const activeProduct = products.find((product: any) => product.active && product.product === account);
        
        if (activeProduct) {
          this.userService.changeCoverage(cognitoId, activeProduct.id.toString(), matchingPoliza.insurance).pipe(
            catchError(err => {
              console.error('Error en changeCoverage', err);
              return of(null);
            })
          ).subscribe(checkResponse => {
            console.log('Coverage check result:', checkResponse);
            this.allServicesClient();
          });
        } else {
          this.allServicesClient();
        }
      } else {
        this.allServicesClient();
      }
    });
  }
}
